import { put, select } from 'redux-saga/effects'
import { takeLatest } from '@redux-saga/core/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { saveIntubation } from '../../intubation/store/intubation.actions'
import { QuickActionsConstants } from '../store/quickActions.constants'

export function* setIntubationQuickActionTimeLineRow() {
  const quickActionsObject = yield select(getQuickActionsSelector)
  const { addIntubationToTimeline } = quickActionsObject
  if (addIntubationToTimeline) {
    yield put(saveIntubation())
  }
}

export function* setIntubationQuickActionTimeLineRowSaga() {
  yield takeLatest([QuickActionsConstants.SET_ADD_INTUBATION_TO_TIMELINE], setIntubationQuickActionTimeLineRow)
}
